import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {fetchColors} from './manageColors';
export const createMasterColorsForm = (color) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/master-vehicles/colors',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_COLOR,
        [
          () => {
            dispatch(fetchColors());
            return {
              'type': ActionTypes.CREATED_COLOR,
            };
          },
          MessageActions.addMessageBoxInfo('Color Creado Satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_COLOR_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': color,
    })
  );
};
